import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  private readonly _outdated$ = new BehaviorSubject<boolean>(false);
  private readonly _latestVersion$ = new BehaviorSubject<string>(environment.version);

  readonly outdated$: Observable<boolean> = this._outdated$.asObservable();
  readonly latestVersion$: Observable<string> = this._latestVersion$.asObservable();

  get currentVersion(): string {
    return environment.version;
  }

  /**
   * Compares the server-reported version against the app's bundled version and
   * flips outdated$ to true if they differ. Once flagged, stays flagged until reload.
   */
  reportServerVersion(serverVersion: string | null): void {
    // TODO: remove debug logging once version-header flow is verified
    console.log('[VersionCheckService] reportServerVersion', {
      serverVersion,
      bundledVersion: environment.version,
      alreadyOutdated: this._outdated$.value
    });

    if (!serverVersion) return;
    if (this._outdated$.value) return;

    const match = this.versionsMatch(environment.version, serverVersion);
    console.log('[VersionCheckService] match result', { match });

    if (!match) {
      this._latestVersion$.next(serverVersion);
      this._outdated$.next(true);
    }
  }

  private versionsMatch(source: string, target: string): boolean {
    if (!source || !target) return false;

    const cleanSource = source.replace(/[^\d.]/g, '');
    const cleanTarget = target.replace(/[^\d.]/g, '');

    const sourceParts = cleanSource.split('.').map(Number);
    const targetParts = cleanTarget.split('.').map(Number);

    const maxLength = Math.max(sourceParts.length, targetParts.length);
    while (sourceParts.length < maxLength) sourceParts.push(0);
    while (targetParts.length < maxLength) targetParts.push(0);

    for (let i = 0; i < maxLength; i++) {
      if (sourceParts[i] !== targetParts[i]) return false;
    }
    return true;
  }
}
